import _inherits from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
export var RestrictedRenderingContext = /*#__PURE__*/function () {
  function RestrictedRenderingContext(viewLayout, viewportData) {
    _classCallCheck(this, RestrictedRenderingContext);

    this._viewLayout = viewLayout;
    this.viewportData = viewportData;
    this.scrollWidth = this._viewLayout.getScrollWidth();
    this.scrollHeight = this._viewLayout.getScrollHeight();
    this.visibleRange = this.viewportData.visibleRange;
    this.bigNumbersDelta = this.viewportData.bigNumbersDelta;

    var vInfo = this._viewLayout.getCurrentViewport();

    this.scrollTop = vInfo.top;
    this.scrollLeft = vInfo.left;
    this.viewportWidth = vInfo.width;
    this.viewportHeight = vInfo.height;
  }

  _createClass(RestrictedRenderingContext, [{
    key: "getScrolledTopFromAbsoluteTop",
    value: function getScrolledTopFromAbsoluteTop(absoluteTop) {
      return absoluteTop - this.scrollTop;
    }
  }, {
    key: "getVerticalOffsetForLineNumber",
    value: function getVerticalOffsetForLineNumber(lineNumber) {
      return this._viewLayout.getVerticalOffsetForLineNumber(lineNumber);
    }
  }, {
    key: "getDecorationsInViewport",
    value: function getDecorationsInViewport() {
      return this.viewportData.getDecorationsInViewport();
    }
  }]);

  return RestrictedRenderingContext;
}();
export var RenderingContext = /*#__PURE__*/function (_RestrictedRenderingC) {
  _inherits(RenderingContext, _RestrictedRenderingC);

  var _super = _createSuper(RenderingContext);

  function RenderingContext(viewLayout, viewportData, viewLines) {
    var _this;

    _classCallCheck(this, RenderingContext);

    _this = _super.call(this, viewLayout, viewportData);
    _this._viewLines = viewLines;
    return _this;
  }

  _createClass(RenderingContext, [{
    key: "linesVisibleRangesForRange",
    value: function linesVisibleRangesForRange(range, includeNewLines) {
      return this._viewLines.linesVisibleRangesForRange(range, includeNewLines);
    }
  }, {
    key: "visibleRangeForPosition",
    value: function visibleRangeForPosition(position) {
      return this._viewLines.visibleRangeForPosition(position);
    }
  }]);

  return RenderingContext;
}(RestrictedRenderingContext);
export var LineVisibleRanges = function LineVisibleRanges(outsideRenderedLine, lineNumber, ranges) {
  _classCallCheck(this, LineVisibleRanges);

  this.outsideRenderedLine = outsideRenderedLine;
  this.lineNumber = lineNumber;
  this.ranges = ranges;
};
export var HorizontalRange = /*#__PURE__*/function () {
  function HorizontalRange(left, width) {
    _classCallCheck(this, HorizontalRange);

    this.left = Math.round(left);
    this.width = Math.round(width);
  }

  _createClass(HorizontalRange, [{
    key: "toString",
    value: function toString() {
      return "[".concat(this.left, ",").concat(this.width, "]");
    }
  }]);

  return HorizontalRange;
}();
export var HorizontalPosition = function HorizontalPosition(outsideRenderedLine, left) {
  _classCallCheck(this, HorizontalPosition);

  this.outsideRenderedLine = outsideRenderedLine;
  this.left = Math.round(left);
};
export var VisibleRanges = function VisibleRanges(outsideRenderedLine, ranges) {
  _classCallCheck(this, VisibleRanges);

  this.outsideRenderedLine = outsideRenderedLine;
  this.ranges = ranges;
};